import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse,
    HttpResponse,
} from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { ClientSessionService } from '../services/application/client-session.service';

@Injectable()
export class ApiResponseInterceptor implements HttpInterceptor {
    public constructor(
        private router: Router,
        private clientSession: ClientSessionService,
    ) {}

    public intercept(
        request: HttpRequest<any>,
        next: HttpHandler,
    ): Observable<HttpEvent<any>> {
        // Clone request with appropriate response type
        request = request.clone({
            responseType:
                request.responseType === 'arraybuffer' ||
                request.responseType === 'blob'
                    ? request.responseType
                    : 'text',
        });

        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                let errorObject = error.error;

                // Parse error object if it's a string
                if (typeof errorObject === 'string') {
                    try {
                        errorObject = JSON.parse(error.error);
                    } catch (e) {
                        errorObject = {
                            message: 'Неподдерживаемый формат ошибки.',
                        };
                    }
                }

                // Handle 401 Unauthorized error
                if (error.status === 401) {
                    this.clientSession.clear();

                    // Redirect to login page unless it's a logout request
                    if (!request.url.includes('logout')) {
                        this.router.navigate(['/auth/login']);
                    }
                }

                return throwError(() => errorObject || error);
            }),
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    const contentTypeHeader = event.headers
                        .get('Content-Type')
                        ?.split(';')[0];
                    const { body } = event;

                    // Parse JSON responses
                    if (
                        body &&
                        typeof body === 'string' &&
                        contentTypeHeader === 'application/json'
                    ) {
                        try {
                            const parsedBody = JSON.parse(body);
                            if (typeof parsedBody === 'object') {
                                return event.clone({
                                    body: parsedBody.data ?? parsedBody,
                                });
                            }
                        } catch (e) {
                            console.error('JSON parsing error', e);
                            return event;
                        }
                    }
                    return event;
                }
                return event;
            }),
        );
    }
}
